import "./BookCover.scss";

import BookCover from "./BookCover";

export default BookCover;
